import { Placement } from "@core/models/placement.model";
import { PlacementSizesRelation } from "@core/models/placement-sizes-relation";

export class PlacementViewModel {
	readonly id: string;
	readonly label: string;
	readonly requiresApproval: boolean = false;

	isSelected: boolean = false;
	isValid: boolean = true;

	constructor (placement: Placement, placementSizeRelation: PlacementSizesRelation | undefined) {

		this.id = placement.id;
		this.label = placement.label || "";

		if (placementSizeRelation) {
			this.requiresApproval = placementSizeRelation.requiresApproval || false;
		}
	}
}
